<!--工作室课程-->
<template>
    <div class="studio_nav_content">
        <!--列表模式-->
        <div class="page-mode" v-show="showMode==='page'">
            <!-- 搜索条件 -->
            <div class="form-box">
                <el-form ref="queryForm"
                         :model="queryParams"
                         :inline="true"
                         label-width="40px">
                    <el-row class="mt10 ml10" >
                        <el-col :span="6" class="mb0">
                            <el-form-item label="学段">
                                <el-select clearable @change="changePeriod" v-model="queryParams.periodKey" placeholder="请选择学段">
                                    <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="mb0">
                            <el-form-item label="年级">
                                <el-select clearable @change="changeGrade" v-model="queryParams.gradeKey" placeholder="请选择年级">
                                    <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="mb0">
                            <el-form-item label="学科">
                                <el-select clearable @change="pageUserLesson(null)" v-model="queryParams.subjectKey" placeholder="学科">
                                    <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="mb0">
                            <el-form-item label="状态">
                                <el-select clearable @change="pageUserLesson(null)" v-model="queryParams.status" placeholder="请选择状态">
                                    <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                                               :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="mt10">
                        <el-col :span="18" class="mr0 mb0">
                            <el-button style="background-color: #0d55a4;color: #fff;" @click="addLesson">新增备课</el-button>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item >
                                <el-input v-model="queryParams.title" placeholder="请输入名称" class="input-with-select">
                                    <template #append>
                                        <el-button type="primary" @click="pageUserLesson(null)" style="background-color: #0d55a4;color: #fff" icon="el-icon-search" />
                                    </template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="right-container">
                <div class="page-info-container">
                    <div class="info-list-container">
                        <div class="course-list-box">
                            <div class="course-item" v-for="item in dataList" :key="item">
                                <el-card :body-style="{ padding: '0px' }" class="course-one" @click="viewLesson(item)">
                                    <div class="course-name">{{item.title}}</div>
                                    <div class="course-info">
                                        <div class="course-cover">
                                            <img class="img-100" :src="item.coverUrl" alt />
                                        </div>
                                        <div class="course-title">
                                            <div class="course-subject">
                                                <div class="sub-info">{{item.periodName}}-{{item.gradeName}}-{{item.subjectName}}</div>
                                                <div class="status-info" v-if="item.status===1">初始</div>
                                                <div class="status-info-fb" v-if="item.status===9">备课完成</div>
                                            </div>
                                            <div class="course-commend">主备人:{{item.leadUserName}}</div>
                                            <div class="course-commend">课题级别:{{item.lessonLevelName}}</div>
                                            <div class="course-commend">备课时间:{{ timestampToTime(item.createTime) }}</div>
                                        </div>
                                    </div>
                                </el-card>
                            </div>
                        </div>
                        <data-empty v-if="dataList&&dataList.length===0" title="暂无数据"/>
                    </div>
                    <div class="page-container" v-if="dataList&&dataList.length>0">
                        <pageTag :background="true"
                                 :pageSizes="[6, 9, 12]"
                                 v-show="total > 0"
                                 :total="total"
                                 v-model:page.sync="queryParams.pageNum"
                                 v-model:limit.sync="queryParams.pageSize"
                                 @pagination="pageUserLesson" />
                    </div>
                </div>
            </div>
        </div>
        <!--详情编辑模式-->
        <div class="detail-mode" v-if="showMode==='detail'">
            <pre-lesson-info :lesson-id="this.lessonId"/>
        </div>
        <!-- 新增模式 -->
        <div class="detail-mode" v-if="showMode==='add'">
            <add-pre-lesson @change-show="changeShow"/>
        </div>
    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import courseInfo from "@/components/course/courseInfo.vue";
import {timestampDate, timestampToTime} from "@/utils/date";
import {queryDict} from "@/api/admin/public";
import {lessonPageLessons} from "@/api/admin/lesson";
import PreLessonInfo from "@/components/eduResearch/preLessonInfo.vue";
import addPreLesson from "@/components/eduResearch/AddPreLesson.vue";

export default {
    name:'pageCourse',
    components:{PreLessonInfo, pageTag, dataEmpty,courseInfo,addPreLesson},
    props:{
        title:{
            type: String,
            default:null
        },
        courseType:{
            type: String,
            default:null
        },
        courseMode:{
            type: String,
            default:'page'
        },
        parentId:{
            type: String,
            default:''
        }
    },
    watch:{
        courseMode(newValue,oldValue){
            this.showMode = newValue;
            this.pageUserLesson();
        },
        parentId(newValue,oldValue){
            this.courseId = newValue;
        },
    },
    mounted() {
        this.getQueryDict();
        this.pageUserLesson();
    },
    data() {
        return {
            showMode:'page',
            timestampDate,
            timestampToTime,
            itemName:'高水平示范课',
            itemKey:'',
            queryParams: {
                status: '',
                title: '',
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                pageNum: 1,
                pageSize: 6,
                type:1
            },
            total: 0,
            pageCount:0,
            dataList: [],
            lessonId:'',
            periodList: [],
            gradeList: [],
            subjectList: [],
            statusList: [
                { name: '初始', value: 1 },
                { name: '备课完成', value: 9 },
            ],
        }
    },
    methods: {
        getQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
        },
        changePeriod() {
            this.queryParams.gradeKey = '';
            this.queryParams.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
            this.pageUserLesson()
        },
        changeGrade() {
            this.queryParams.subjectKey = '';
            this.subjectList = []
            this.periodList.forEach(e => {
                if (this.queryParams.periodKey === e.dictKey) {
                    e.childrenList.forEach(j => {
                        if (this.queryParams.gradeKey === j.dictKey) {
                            this.subjectList = j.childrenList;
                        }
                    })
                }
            })
            this.pageUserLesson()
        },
        pageUserLesson(){
            lessonPageLessons(this.queryParams).then(res => {
                this.dataList = res.data.data.list;
                this.total = res.data.data.total;
                this.pageCount = res.data.data.totalPage;

            });
        },
        viewLesson(item){
            this.showMode = "detail"
            this.lessonId = item.lessonId;
            this.$emit('change-mode',this.showMode);
        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode, 5);
        },
        addLesson(){
            this.showMode = "add";
            this.$emit('change-mode',this.showMode);
        },
        changeShow(item){
            this.pageUserLesson()
            this.showMode = item;
        }
    }
}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
}
.page-mode{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
}
.form-box{
    width: 98%;
    height: auto;
    margin: auto;
    border-bottom: 2px solid #0d55a4;
    background-color: #fff;
    padding-top: 5px;
}
.right-container{
    width: 100%;
    height: auto;
}
.page-info-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    background-color: #fff;
}
.info-top-title{
    width: 99%;
    height: 34px;
    margin: auto;
    line-height: 30px;
    font-size: 16px;
    font-weight: 400;
    display: flex;
    flex-direction: column;
}
.title{
    padding-right: 10px;
    border-bottom: 2px solid #0d55a4;
}

.info-list-container{
    width: 100%;
    height: calc(100vh - 260px)!important;
    margin: auto;
    overflow-x: hidden;
}
/*课程*/
.course-list-box{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    padding-right: 10px;
    padding-top: 10px;
    align-items: center;
    box-sizing: border-box;
    background-color: #fff;
}
.course-item{
    width: 33.3%!important;
    height: auto;
    padding-left: 10px;
    padding-bottom: 10px;
    box-sizing: border-box;
}
.course-one{
    width: 100%;
    height: 100%;
    padding: 10px;
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
}
.course-info{
    display: flex;
    width: 100%;
    height: 100px;
    padding-top: 10px;
}
.course-cover{
    width: 40%;
    height: 100%;
    box-shadow: var(--el-box-shadow-light);
    img{
        width: 100%;
        height: 100%;
    }
}
.course-title{
    width: 60%;
    height: 100%;
}
.course-name{
    width: 100%;
    font-size: 15px;
    color: #333;
    font-weight: bold;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    height: 42px;
}
.course-time{
    width: 100%;
    font-size: 14px;
    color: #333;
    height: 20px;
    line-height: 20px;
}
.course-subject{
    padding-left: 10px;
    box-sizing: border-box;
    font-size: 14px;
    color: #333333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 25px;
    display: flex;
}
.sub-info{
    width: calc(100% - 50px);
    color: #333333;
    height: 30px;
    line-height: 30px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.status-info{
    width: 50px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #a2ef4d;
    font-size: 12px;
    text-align: center;
    color: #e87b17;
    margin-top: 5px;
}
.status-info-fb{
    width: 50px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #e87b17;
    font-size: 12px;
    text-align: center;
    color: #a2ef4d;
    margin-top: 5px;
}
.course-commend{
    padding-left: 10px;
    padding-top: 2px;
    box-sizing: border-box;
    color: #333333;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
}
.course-team-user{
    padding-left: 10px;
    padding-top: 2px;
    box-sizing: border-box;
    color: #333333;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 40px;
    padding-top: 15px;
    box-sizing: border-box;
}
.detail-mode{
    width: 100%;
    height: auto;
}
</style>